let promocodesShort = null;
let promocodesFull = null;
let showFullContent = false;

const hideButtonHandler = () => {
  if (showFullContent) {
    const container = document.querySelector('#content-container');
    if (container) {
      container.innerHTML = promocodesShort;
      showFullContent = false;
      window.initHideButton();
      window.initCopyButtons();
    }
  } else {
    const container = document.querySelector('#content-container');

    if (container) {
      container.innerHTML = promocodesFull;
      showFullContent = true;
      window.initHideButton();
      window.initCopyButtons();
    }
  }
};

const clickHandler = async () => {
  if (window.loaderShow) {
    window.loaderShow('#content-container');
  }

  const rawResponse = await fetch('/local/components/panfilov/partners.detail/ajax.php?page=2');
  const responseToString = await rawResponse.text();

  const container = document.querySelector('#content-container');

  if (container && responseToString) {
    promocodesShort = container.innerHTML;
    promocodesFull = responseToString;

    container.innerHTML = responseToString;
    showFullContent = true;
    window.initHideButton();
  }
};

const initButton = () => {
  const showMoreButton = document.querySelector('[data-button-type="jsShowMoreButton"]');

  if (showMoreButton && !showMoreButton.classList.contains('_init')) {
    showMoreButton.addEventListener('click', clickHandler);

    showMoreButton.classList.add('_init');
  }
};

const initHideButton = () => {
  const hideButton = document.querySelector('[data-button-type="jsShowMoreButton"]');

  if (hideButton) {
    hideButton.addEventListener('click', hideButtonHandler);
  }
};

window.initHideButton = initHideButton;

initButton();
